import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const BRAND = "#1C4E6D";

// F29/Batch 11: shared page navigator for server-side paginated list views
const PageNavigator = ({ currentPage, totalPages, totalElements, pageSize, onPageChange }) => {
  if (totalElements === 0) {
    return (
      <div className="flex items-center justify-center p-4 border-t bg-gray-50">
        <span className="text-sm text-gray-600">No records found</span>
      </div>
    );
  }

  const start = currentPage * pageSize + 1;
  const end = Math.min(totalElements, (currentPage + 1) * pageSize);

  const getPageNumbers = () => {
    const pages = new Set();
    pages.add(0);
    pages.add(totalPages - 1);
    for (let p = currentPage - 2; p <= currentPage + 2; p++) {
      if (p >= 0 && p < totalPages) pages.add(p);
    }
    return [...pages].sort((a, b) => a - b);
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex items-center justify-center p-4 border-t bg-gray-50">
      <div className="flex items-center gap-4">
        <span className="text-sm text-gray-600">
          Showing {start}-{end} of {totalElements}
        </span>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 0}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-500 disabled:opacity-50"
        >
          <ChevronLeft size={16} /> Prev
        </button>

        {pageNumbers.map((p, idx) => {
          const prev = pageNumbers[idx - 1];
          const showEllipsis = idx > 0 && p - prev > 1;
          return (
            <React.Fragment key={p}>
              {showEllipsis && <span className="px-1 text-sm text-gray-400">...</span>}
              <button
                onClick={() => onPageChange(p)}
                className="px-3 py-2 text-sm rounded"
                style={p === currentPage
                  ? { backgroundColor: BRAND, color: '#fff' }
                  : { color: '#374151' }}
              >
                {p + 1}
              </button>
            </React.Fragment>
          );
        })}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages - 1}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-500 disabled:opacity-50"
        >
          Next <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default PageNavigator;
